module.exports = __webpack_public_path__ + "img/crew1_7-8-2021.297f85d5.jpg";